import { render, staticRenderFns } from "./LiquorAreaList.vue?vue&type=template&id=12257108&scoped=true&"
import script from "./LiquorAreaList.vue?vue&type=script&lang=js&"
export * from "./LiquorAreaList.vue?vue&type=script&lang=js&"
import style0 from "./LiquorAreaList.vue?vue&type=style&index=0&id=12257108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12257108",
  null
  
)

export default component.exports